import numeral from 'numeral';

export class FileSizeValueConverter {
  toView(value) {
    return numeral(value).format('0 b');
  }
}
